import React, { Component } from 'react';

export default class OpinionInfo extends Component {
	renderContacts( contact, i ) {
		return (<p className="firm-contacts" key={ i }>
				<strong>Contact:</strong>&nbsp;
				<span className="contact-name">{ contact.name }</span>&nbsp;
				<a href={ `mailto:${ contact.email }` } target="_blank"
				   className="contact-email">
					<span className="glyphicon glyphicon-envelope"
					      aria-hidden="true"></span>&nbsp;Send Email</a>
			</p>
		);
	}

	renderFirm( opinion ) {
		if ( opinion.firm_name.length ) {
			return (<div className="firm-name">
					<strong>Law Firm:</strong>&nbsp;
					{ opinion.firm_name }
				</div>
			);
		}
	}

	renderStatus( opinion ) {
		if ( opinion.opinion_status ) {
			return (<div className="status">
					<strong>Status:</strong>&nbsp;
					{ opinion.opinion_status }
				</div>
			);
		}
	}

	render() {
		const opinion = this.props.opinion;

		return (<div className="col-sm-8 opinion-info">
				<div className="row no-gutter">
					<div className="col-sm-6">
						<h3 className="entry-title">
							<a href={ opinion.opinion_permalink }
							   dangerouslySetInnerHTML={ { __html: opinion.title.rendered || opinion.title } }/>
						</h3>
						<div className="firm-name">
							<strong>Last Updated:</strong>&nbsp;
							{ opinion.last_updated }
						</div>

						{ this.renderFirm( opinion ) }

						{ opinion.firm_contacts.map( ( contact, i ) => {
							return this.renderContacts( contact, i );
						} ) }

					</div>
					<div className="col-sm-6 flag-status">
						<div className="bookmark-container">
							<div className="bookmark">
								<i className={ `fa-bookmark ${ ISDA_Main.userBookmarks.includes( opinion.id )
								                               ? 'fa'
								                               : 'fa-regular' } toggle-bookmark` }
								   data-post-id={ opinion.id }></i>
							</div>
						</div>
						<img width="100%" height="auto"
						     src={ opinion.featured_media_src }
						     className="opinion-flag wp-post-image flag-small"
						     alt=""/>
						{ this.renderStatus( opinion ) }

					</div>
				</div>
			</div>
		);
	}
}